<template>
<div class="container">

    <header class="container__header">

        <h1>Pakkeliste</h1>

    </header>

    <div class="container__body container__body--md">

        <section class="data-list">

            <header class="col-12 padding-b-25 margin-b-25 border-b">

                <h1>Ordre</h1>

            </header>

            <div class="item" v-for="order in orders">

                <div class="icon">

                    <i class="icon--lg fas fa-inbox"></i>

                </div>

                <div class="content">

                    <h1>{{order.product_title}}</h1>

                    <ul>

                        <li>Ordre: {{order.id}}, Dato: {{order.deliver_at | moment('DD/MM/YYYY')}}</li>

                    </ul>

                </div>

                <div class="link">

                    <router-link :to="{name:'order.search.order', params:{order:order.id}}">Se ordre</router-link>

                </div>

            </div>

            <h4 v-if="orders.length === 0">Ingen ordrer fundet</h4>

        </section>

    </div>

</div>

</template>

<script>
export default {
    name: 'order',
    data(){
        return {
            orders:[],
        };
    },
    created(){
        axios.get('/api/admin/productless/order/delivery').then(response => {
            this.orders = response.data.data;
        })
    }
}
</script>
